export const MAX_ATTEMPTS = 3;
export const ATTEMPTS_STORAGE_KEY = 'attemptsStorageKey';
